import { getNotificationsThunk } from "../store/notification/thunks";
import { selectIsLoggedIn } from "../store/auth/selectors";
import { useDispatch, useSelector } from "../store/store";
import { useEffect } from "react";

const REFETCH_INTERVAL = 60000;

/** Keeps the notifications menu in sync while the user stays signed in. */
export const useNotifications = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(selectIsLoggedIn);

    useEffect(() => {
        if (!isLoggedIn) return;

        dispatch(getNotificationsThunk());
        const intervalId = setInterval(() => dispatch(getNotificationsThunk()), REFETCH_INTERVAL);

        return () => clearInterval(intervalId);
    }, [isLoggedIn]);
};
